module.exports = __webpack_public_path__ + "img/bps.45cf3d35.png";